import { TeamTurns } from "./Game";
import { Difficulty } from "./Question";
import { SchoolType } from "./User";

export interface CategoryEntity {
  _id?: string;
  title?: string;
  imageUrl?: string;
  schoolType?: SchoolType;
}

export interface Category {
  id: string;
  title: string;
  imageUrl: string;
  isSelected: boolean;
  schoolType: SchoolType;
  pointsHashmap: Map<TeamTurns, Map<Difficulty, boolean>>;
}

export function convertCategoryEntityToCategory(
  categoryEntity: CategoryEntity,
): Category {
  const pointsHashmap: Map<TeamTurns, Map<Difficulty, boolean>> = new Map([
    [
      TeamTurns.teamA,
      new Map([
        [Difficulty.EASY, false],
        [Difficulty.MEDIUM, false],
        [Difficulty.HARD, false],
      ]),
    ],
    [
      TeamTurns.teamB,
      new Map([
        [Difficulty.EASY, false],
        [Difficulty.MEDIUM, false],
        [Difficulty.HARD, false],
      ]),
    ],
  ]);
  return {
    id: categoryEntity._id!,
    title: categoryEntity.title!,
    imageUrl: categoryEntity.imageUrl!,
    schoolType: categoryEntity.schoolType!,
    isSelected: false,
    pointsHashmap: pointsHashmap,
  };
}

export function convertCategoryEntityListToCategoryList(
  categoryEntities: Array<CategoryEntity>,
): Array<Category> {
  const categories: Array<Category> = [];

  categoryEntities.map((categoryEntity, i) => {
    categories.push(convertCategoryEntityToCategory(categoryEntity));
  });
  return categories;
}
